import { render, staticRenderFns } from "./copyInsert.vue?vue&type=template&id=40eeb9ce&scoped=true"
import script from "./copyInsert.vue?vue&type=script&lang=js"
export * from "./copyInsert.vue?vue&type=script&lang=js"
import style0 from "./copyInsert.vue?vue&type=style&index=0&id=40eeb9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eeb9ce",
  null
  
)

export default component.exports